import React from 'react'
// import SpinnerLoader from "../../Asset/Images/Loader/spinner-loader.svg"
import SpinnerLoader from "../../assets/Images/Loader/spinner-loader.svg"

export default function PageLoader() {
  return ((<div className='py-5 text-center'>
    <img src={SpinnerLoader} height="100px" width={'100px'} />
  </div>))
}
